// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".insight {\n  box-shadow: 0px 0px 6px #0000001c;\n  letter-spacing: 0.05em;\n  display: flex;\n  align-items: center;\n  margin-top: 1.5625em;\n}\n\n@media all and (max-width: 576px) {\n  .insight {\n    font-size: 0.85rem;\n  }\n}", ""]);
// Exports
module.exports = exports;
